import Model from 'cdna/core/model';
import VideoCollection from './videoCollection.js';
import {calculateDuration} from '../util.js';

export default Model.extend({
    defaults: {
        toggled: true
    },
    modelTypes: {
        Videos: VideoCollection
    },
    computed: {
        'duration Videos': function(videos) {
            var durations = videos.pluck('Duration');
            return Math.max.apply(Math, durations);
        },
        'durationDescription duration': calculateDuration
    },
    initialize() {
        this.on('add:Videos', this.videoAdded, this);
        this.on('remove:Videos', this.videoRemoved, this);
        this.on('reset:Videos', function(options) {
            _.each(options.previousModels, this.videoRemoved, this);
        }, this);
        this.get('Videos').each(this.videoAdded, this);
    },
    videoAdded(video) {
        video.set('GroupTitle', this.get('Title'));
    },
    videoRemoved(video) {
        video.unset('GroupTitle');
    }
});


/** WEBPACK FOOTER **
 ** ./client/video/videoGroup.js
 **/